/* tslint:disable */
/* eslint-disable */
/**
 * UPSIDER Core IAM API Specifications
 * Contains specifications for Core IAM, defining only the specifications for the REST API and not including specifications for GraphQL, gRPC, etc.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccessTokenForm
 */
export interface AccessTokenForm {
    /**
     * 
     * @type {string}
     * @memberof AccessTokenForm
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessTokenForm
     */
    'refreshToken'?: string | null;
}
/**
 * 
 * @export
 * @interface AccessTokenResponse
 */
export interface AccessTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof AccessTokenResponse
     */
    'accessToken': string;
    /**
     * 
     * @type {string}
     * @memberof AccessTokenResponse
     */
    'refreshToken': string;
    /**
     * 
     * @type {number}
     * @memberof AccessTokenResponse
     */
    'refreshTokenExpiresAt': number;
}
/**
 * 
 * @export
 * @interface AuthenticationClaimResponse
 */
export interface AuthenticationClaimResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof AuthenticationClaimResponse
     */
    'scopes': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AuthenticationClaimResponse
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface AuthenticationResponse
 */
export interface AuthenticationResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResponse
     */
    'smsPhoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResponse
     */
    'tfaToken'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AuthenticationResponse
     */
    'tfaTokenExpiresAt'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResponse
     */
    'token'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResponse
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface BuildConfigResponse
 */
export interface BuildConfigResponse {
    /**
     * 
     * @type {string}
     * @memberof BuildConfigResponse
     */
    'branch': string;
    /**
     * 
     * @type {string}
     * @memberof BuildConfigResponse
     */
    'version': string;
}
/**
 * 
 * @export
 * @interface CheckAlreadyRegisteredPhoneNumberForm
 */
export interface CheckAlreadyRegisteredPhoneNumberForm {
    /**
     * 
     * @type {string}
     * @memberof CheckAlreadyRegisteredPhoneNumberForm
     */
    'phoneNumber': string;
}
/**
 * 
 * @export
 * @interface CheckAlreadyRegisteredPhoneNumberResponse
 */
export interface CheckAlreadyRegisteredPhoneNumberResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CheckAlreadyRegisteredPhoneNumberResponse
     */
    'registered': boolean;
}
/**
 * 
 * @export
 * @interface CreateUniversalOrganizationResponseDefault
 */
export interface CreateUniversalOrganizationResponseDefault {
    /**
     * 
     * @type {string}
     * @memberof CreateUniversalOrganizationResponseDefault
     */
    'error'?: string | null;
    /**
     * 
     * @type {UniversalOrganization}
     * @memberof CreateUniversalOrganizationResponseDefault
     */
    'organization'?: UniversalOrganization;
    /**
     * 
     * @type {UniversalOrganizationId}
     * @memberof CreateUniversalOrganizationResponseDefault
     */
    'universalOid'?: UniversalOrganizationId;
}
/**
 * 
 * @export
 * @interface GenerateAccessTokenForm
 */
export interface GenerateAccessTokenForm {
    /**
     * 
     * @type {string}
     * @memberof GenerateAccessTokenForm
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface GenerateAccessTokenResponse
 */
export interface GenerateAccessTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof GenerateAccessTokenResponse
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface GetSamlConfigurationResponse
 */
export interface GetSamlConfigurationResponse {
    /**
     * 
     * @type {string}
     * @memberof GetSamlConfigurationResponse
     */
    'certificate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSamlConfigurationResponse
     */
    'enabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSamlConfigurationResponse
     */
    'enforced': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSamlConfigurationResponse
     */
    'entityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSamlConfigurationResponse
     */
    'loginUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSamlConfigurationResponse
     */
    'provider': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSamlConfigurationResponse
     */
    'tfaEnabled': boolean;
}
/**
 * 
 * @export
 * @interface GetSamlMetadataResponse
 */
export interface GetSamlMetadataResponse {
    /**
     * 
     * @type {string}
     * @memberof GetSamlMetadataResponse
     */
    'appName': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSamlMetadataResponse
     */
    'isSp': boolean;
}
/**
 * 
 * @export
 * @interface GetScimConfigurationResponse
 */
export interface GetScimConfigurationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetScimConfigurationResponse
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetScimConfigurationResponse
     */
    'provider': string;
}
/**
 * 
 * @export
 * @interface GetScimJwtResponse
 */
export interface GetScimJwtResponse {
    /**
     * 
     * @type {number}
     * @memberof GetScimJwtResponse
     */
    'createdAt': number;
    /**
     * 
     * @type {string}
     * @memberof GetScimJwtResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetScimJwtResponse
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface GetScimJwtsResponse
 */
export interface GetScimJwtsResponse {
    /**
     * 
     * @type {Array<GetScimJwtResponse>}
     * @memberof GetScimJwtsResponse
     */
    'results': Array<GetScimJwtResponse>;
}
/**
 * 
 * @export
 * @interface InternalAccessCheckResponse
 */
export interface InternalAccessCheckResponse {
    /**
     * 
     * @type {string}
     * @memberof InternalAccessCheckResponse
     */
    'scopes': string;
    /**
     * 
     * @type {string}
     * @memberof InternalAccessCheckResponse
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface JWTSSOPCVerifyResponse
 */
export interface JWTSSOPCVerifyResponse {
    /**
     * 
     * @type {string}
     * @memberof JWTSSOPCVerifyResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface LoginForm
 */
export interface LoginForm {
    /**
     * 
     * @type {string}
     * @memberof LoginForm
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LoginForm
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface LoginOptionForm
 */
export interface LoginOptionForm {
    /**
     * 
     * @type {string}
     * @memberof LoginOptionForm
     */
    'clientType': string;
    /**
     * 
     * @type {string}
     * @memberof LoginOptionForm
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LoginOptionForm
     */
    'redirectUrl': string;
}
/**
 * 
 * @export
 * @interface LoginResponse
 */
export interface LoginResponse {
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    'grantCode': string;
}
/**
 * 
 * @export
 * @interface LoginWithPasswordForm
 */
export interface LoginWithPasswordForm {
    /**
     * 
     * @type {string}
     * @memberof LoginWithPasswordForm
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginWithPasswordForm
     */
    'password'?: string | null;
}
/**
 * 
 * @export
 * @interface LoginWithTwoFactorAuthAppForm
 */
export interface LoginWithTwoFactorAuthAppForm {
    /**
     * 
     * @type {string}
     * @memberof LoginWithTwoFactorAuthAppForm
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof LoginWithTwoFactorAuthAppForm
     */
    'tfaToken': string;
    /**
     * 
     * @type {string}
     * @memberof LoginWithTwoFactorAuthAppForm
     */
    'verificationCode': string;
}
/**
 * 
 * @export
 * @interface LoginWithTwoFactorAuthRecoveryCodeForm
 */
export interface LoginWithTwoFactorAuthRecoveryCodeForm {
    /**
     * 
     * @type {string}
     * @memberof LoginWithTwoFactorAuthRecoveryCodeForm
     */
    'emailAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginWithTwoFactorAuthRecoveryCodeForm
     */
    'recoveryCode'?: string | null;
}
/**
 * 
 * @export
 * @interface LoginWithTwoFactorAuthSmsForm
 */
export interface LoginWithTwoFactorAuthSmsForm {
    /**
     * 
     * @type {string}
     * @memberof LoginWithTwoFactorAuthSmsForm
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof LoginWithTwoFactorAuthSmsForm
     */
    'idToken': string;
    /**
     * 
     * @type {string}
     * @memberof LoginWithTwoFactorAuthSmsForm
     */
    'tfaToken': string;
}
/**
 * 
 * @export
 * @interface OrganizationIdentifier
 */
export interface OrganizationIdentifier {
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentifier
     */
    'entityCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentifier
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface OrganizationIdentifierForm
 */
export interface OrganizationIdentifierForm {
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentifierForm
     */
    'entityCode': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentifierForm
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface PasswordResetAppVerificationForm
 */
export interface PasswordResetAppVerificationForm {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetAppVerificationForm
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetAppVerificationForm
     */
    'verificationCode': string;
}
/**
 * 
 * @export
 * @interface PasswordResetConfirmationForm
 */
export interface PasswordResetConfirmationForm {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetConfirmationForm
     */
    'confirmationPassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetConfirmationForm
     */
    'newPassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetConfirmationForm
     */
    'token'?: string | null;
}
/**
 * 
 * @export
 * @interface PasswordResetForm
 */
export interface PasswordResetForm {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetForm
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface PasswordResetRecoveryCodeForm
 */
export interface PasswordResetRecoveryCodeForm {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetRecoveryCodeForm
     */
    'recoveryCode': string;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetRecoveryCodeForm
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface PasswordResetSmsVerificationForm
 */
export interface PasswordResetSmsVerificationForm {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetSmsVerificationForm
     */
    'firebaseIdToken': string;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetSmsVerificationForm
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface PasswordResetTokenResponse
 */
export interface PasswordResetTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetTokenResponse
     */
    'smsPhoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetTokenResponse
     */
    'twoFactorAuthRegisterStatus': string;
    /**
     * 
     * @type {boolean}
     * @memberof PasswordResetTokenResponse
     */
    'valid': boolean;
}
/**
 * 
 * @export
 * @interface PasswordResetVerificationResponse
 */
export interface PasswordResetVerificationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PasswordResetVerificationResponse
     */
    'valid': boolean;
}
/**
 * 
 * @export
 * @interface RegisterAppAuthForm
 */
export interface RegisterAppAuthForm {
    /**
     * 
     * @type {string}
     * @memberof RegisterAppAuthForm
     */
    'verificationCode': string;
}
/**
 * 
 * @export
 * @interface RegisterSmsAuthForm
 */
export interface RegisterSmsAuthForm {
    /**
     * 
     * @type {string}
     * @memberof RegisterSmsAuthForm
     */
    'idToken': string;
}
/**
 * 
 * @export
 * @interface SAMLRedirectRequest
 */
export interface SAMLRedirectRequest {
    /**
     * 
     * @type {string}
     * @memberof SAMLRedirectRequest
     */
    'spid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLRedirectRequest
     */
    'RelayState'?: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLRedirectRequest
     */
    'SAMLRequest'?: string;
}
/**
 * 
 * @export
 * @interface SAMLRedirectResponse
 */
export interface SAMLRedirectResponse {
    /**
     * 
     * @type {string}
     * @memberof SAMLRedirectResponse
     */
    'post_url': string;
    /**
     * 
     * @type {string}
     * @memberof SAMLRedirectResponse
     */
    'RelayState': string;
    /**
     * 
     * @type {string}
     * @memberof SAMLRedirectResponse
     */
    'SAMLResponse': string;
}
/**
 * 
 * @export
 * @interface SamlConfigurationResponse
 */
export interface SamlConfigurationResponse {
    /**
     * 
     * @type {string}
     * @memberof SamlConfigurationResponse
     */
    'ssoUrl': string;
    /**
     * 
     * @type {boolean}
     * @memberof SamlConfigurationResponse
     */
    'tfaEnabledByOrg': boolean;
}
/**
 * 
 * @export
 * @interface SamlLoginOptionResponse
 */
export interface SamlLoginOptionResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof SamlLoginOptionResponse
     */
    'loginOptions': Array<string>;
    /**
     * 
     * @type {SamlConfigurationResponse}
     * @memberof SamlLoginOptionResponse
     */
    'samlConfiguration'?: SamlConfigurationResponse;
}
/**
 * 
 * @export
 * @interface ScimJwtResponse
 */
export interface ScimJwtResponse {
    /**
     * 
     * @type {number}
     * @memberof ScimJwtResponse
     */
    'expiresAt': number;
    /**
     * 
     * @type {string}
     * @memberof ScimJwtResponse
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface TwoFactorAuthRegistrationResponse
 */
export interface TwoFactorAuthRegistrationResponse {
    /**
     * 
     * @type {string}
     * @memberof TwoFactorAuthRegistrationResponse
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface UniversalOrganization
 */
export interface UniversalOrganization {
    /**
     * 
     * @type {string}
     * @memberof UniversalOrganization
     */
    'corporateNumber'?: string | null;
    /**
     * 
     * @type {UniversalOrganizationId}
     * @memberof UniversalOrganization
     */
    'id': UniversalOrganizationId;
    /**
     * 
     * @type {string}
     * @memberof UniversalOrganization
     */
    'legalName': string;
    /**
     * 
     * @type {Array<OrganizationIdentifier>}
     * @memberof UniversalOrganization
     */
    'organizationIdentifiers'?: Array<OrganizationIdentifier>;
    /**
     * 
     * @type {Array<UniversalUser>}
     * @memberof UniversalOrganization
     */
    'users'?: Array<UniversalUser>;
}
/**
 * 
 * @export
 * @interface UniversalOrganizationFormDefault
 */
export interface UniversalOrganizationFormDefault {
    /**
     * 
     * @type {string}
     * @memberof UniversalOrganizationFormDefault
     */
    'corporateNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniversalOrganizationFormDefault
     */
    'legalName': string;
    /**
     * 
     * @type {Array<OrganizationIdentifierForm>}
     * @memberof UniversalOrganizationFormDefault
     */
    'organizationIdentifiers': Array<OrganizationIdentifierForm>;
    /**
     * 
     * @type {Array<UniversalUserForm>}
     * @memberof UniversalOrganizationFormDefault
     */
    'users': Array<UniversalUserForm>;
}
/**
 * 
 * @export
 * @interface UniversalOrganizationId
 */
export interface UniversalOrganizationId {
    /**
     * 
     * @type {number}
     * @memberof UniversalOrganizationId
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface UniversalUser
 */
export interface UniversalUser {
    /**
     * 
     * @type {string}
     * @memberof UniversalUser
     */
    'email': string;
    /**
     * 
     * @type {UniversalUserId}
     * @memberof UniversalUser
     */
    'id': UniversalUserId;
    /**
     * 
     * @type {string}
     * @memberof UniversalUser
     */
    'name': string;
    /**
     * 
     * @type {UniversalOrganizationId}
     * @memberof UniversalUser
     */
    'universalOid': UniversalOrganizationId;
    /**
     * 
     * @type {Array<UserIdentifier>}
     * @memberof UniversalUser
     */
    'userIdentifiers'?: Array<UserIdentifier>;
}
/**
 * 
 * @export
 * @interface UniversalUserForm
 */
export interface UniversalUserForm {
    /**
     * 
     * @type {string}
     * @memberof UniversalUserForm
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof UniversalUserForm
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UniversalUserForm
     */
    'passwordEncrypted': string;
    /**
     * 
     * @type {string}
     * @memberof UniversalUserForm
     */
    'passwordSalt': string;
    /**
     * 
     * @type {Array<UserIdentifierForm>}
     * @memberof UniversalUserForm
     */
    'userIdentifiers': Array<UserIdentifierForm>;
}
/**
 * 
 * @export
 * @interface UniversalUserId
 */
export interface UniversalUserId {
    /**
     * 
     * @type {number}
     * @memberof UniversalUserId
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface UpdatePasswordForm
 */
export interface UpdatePasswordForm {
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordForm
     */
    'confirmationPassword': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordForm
     */
    'currentPassword': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordForm
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface UpdateSamlConfigurationForm
 */
export interface UpdateSamlConfigurationForm {
    /**
     * 
     * @type {string}
     * @memberof UpdateSamlConfigurationForm
     */
    'certificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSamlConfigurationForm
     */
    'entityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSamlConfigurationForm
     */
    'loginUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSamlConfigurationForm
     */
    'provider': string;
}
/**
 * 
 * @export
 * @interface UpdateScimConfigurationForm
 */
export interface UpdateScimConfigurationForm {
    /**
     * 
     * @type {string}
     * @memberof UpdateScimConfigurationForm
     */
    'provider': string;
}
/**
 * 
 * @export
 * @interface UpdateTempPasswordForm
 */
export interface UpdateTempPasswordForm {
    /**
     * 
     * @type {string}
     * @memberof UpdateTempPasswordForm
     */
    'confirmationPassword': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTempPasswordForm
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface UserIdentifier
 */
export interface UserIdentifier {
    /**
     * 
     * @type {string}
     * @memberof UserIdentifier
     */
    'entityCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserIdentifier
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface UserIdentifierForm
 */
export interface UserIdentifierForm {
    /**
     * 
     * @type {string}
     * @memberof UserIdentifierForm
     */
    'entityCode': string;
    /**
     * 
     * @type {string}
     * @memberof UserIdentifierForm
     */
    'value': string;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generate access token by grant code
         * @summary Generate access token
         * @param {GenerateAccessTokenForm} generateAccessTokenForm Form to generate access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessTokenPost: async (generateAccessTokenForm: GenerateAccessTokenForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateAccessTokenForm' is not null or undefined
            assertParamExists('accessTokenPost', 'generateAccessTokenForm', generateAccessTokenForm)
            const localVarPath = `/access_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateAccessTokenForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check the phone number is not registered to anyone
         * @summary Check already registered phone number
         * @param {CheckAlreadyRegisteredPhoneNumberForm} checkAlreadyRegisteredPhoneNumberForm Form required for checking already registered phone number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAlreadyRegisteredPhoneNumber: async (checkAlreadyRegisteredPhoneNumberForm: CheckAlreadyRegisteredPhoneNumberForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkAlreadyRegisteredPhoneNumberForm' is not null or undefined
            assertParamExists('checkAlreadyRegisteredPhoneNumber', 'checkAlreadyRegisteredPhoneNumberForm', checkAlreadyRegisteredPhoneNumberForm)
            const localVarPath = `/two_factor_auth/sms/check_already_registered_phone_number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkAlreadyRegisteredPhoneNumberForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete access token for use with scim
         * @summary Delete scim access token
         * @param {number} organizationId 
         * @param {string} accessTokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScimAccessToken: async (organizationId: number, accessTokenId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteScimAccessToken', 'organizationId', organizationId)
            // verify required parameter 'accessTokenId' is not null or undefined
            assertParamExists('deleteScimAccessToken', 'accessTokenId', accessTokenId)
            const localVarPath = `/organizations/{organizationId}/scim/access_tokens/{accessTokenId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"accessTokenId"}}`, encodeURIComponent(String(accessTokenId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disable saml as a means of authenticating members of the organization
         * @summary Disable saml
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableSaml: async (organizationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('disableSaml', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/saml/disable`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disable scim for the organization
         * @summary Disable scim
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableScim: async (organizationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('disableScim', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/scim/disable`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disable 2FA related to saml
         * @summary Disable two factor auth for saml
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableTwoFactorAuth: async (organizationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('disableTwoFactorAuth', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/saml/two_factor_auth/disable`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow the use of saml as a means of authenticating members of the organization
         * @summary Enable saml
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableSaml: async (organizationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('enableSaml', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/saml/enable`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable scim for the organization
         * @summary Enable scim
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableScim: async (organizationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('enableScim', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/scim/enable`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable 2FA related to saml
         * @summary Enable two factor auth for saml
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableTwoFactorAuth: async (organizationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('enableTwoFactorAuth', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/saml/two_factor_auth/enable`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enforce saml as a means of authenticating members of the organization
         * @summary Enforce saml
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enforceSaml: async (organizationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('enforceSaml', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/saml/enforce`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate access token for use with scim
         * @summary Generate scim access token
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateScimAccessToken: async (organizationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('generateScimAccessToken', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/scim/access_tokens`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a new JWT for SSO from recieved JWT and sets it to cookie.
         * @summary Sets a JWT for SSO to cookie.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJwtSso: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/saml/jwtsso`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns valid login methods for organization
         * @summary Get login options
         * @param {string} email 
         * @param {string} clientType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoginOptions: async (email: string, clientType: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getLoginOptions', 'email', email)
            // verify required parameter 'clientType' is not null or undefined
            assertParamExists('getLoginOptions', 'clientType', clientType)
            const localVarPath = `/login/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (clientType !== undefined) {
                localVarQueryParameter['clientType'] = clientType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the metadata xml for SAML SSO of Moneytree.
         * @summary Returns the metadata xml.
         * @param {string} spid spid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetadata: async (spid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'spid' is not null or undefined
            assertParamExists('getMetadata', 'spid', spid)
            const localVarPath = `/v2/saml/metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (spid !== undefined) {
                localVarQueryParameter['spid'] = spid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a new President Card JWT for SSO from recieved JWT and sets it to cookie.
         * @summary Sets a President Card JWT for SSO to the cookie.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPcJwtSso: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/saml/jwtsso/pc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get configuration for use with saml
         * @summary Get saml configuration
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamlConfiguration: async (organizationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSamlConfiguration', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/saml/configuration`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get metadata
         * @summary Get saml metadata
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamlMetadata: async (organizationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSamlMetadata', 'organizationId', organizationId)
            const localVarPath = `/saml/metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get access token for use with scim
         * @summary Get scim access tokens
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScimAccessToken: async (organizationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getScimAccessToken', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/scim/access_tokens`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get configuration for use with scim
         * @summary Get scim configuration
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScimConfiguration: async (organizationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getScimConfiguration', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/scim/configuration`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate QR Code for two factor authentication
         * @summary Generate QR Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaAppQrCode: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/two_factor_auth/app/generate_qr_code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download recovery code for two factor authentication
         * @summary Download recovery code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaAppRecoveryCode: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/two_factor_auth/app/download_recovery_code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download recovery code for two factor authentication
         * @summary Download recovery code for SMS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaSmsRecoveryCode: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/two_factor_auth/sms/download_recovery_code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check application startup and retrieve running branch name and image hash.
         * @summary Health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health_check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if the user has access to the specified scope
         * @summary Access Scope Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves an access token for a given grant code or refresh token
         * @summary Retrieves an access token
         * @param {AccessTokenForm} accessTokenForm The form required to request this api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalV1AccessTokenPost: async (accessTokenForm: AccessTokenForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessTokenForm' is not null or undefined
            assertParamExists('internalV1AccessTokenPost', 'accessTokenForm', accessTokenForm)
            const localVarPath = `/internal/v1/access_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accessTokenForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or update an organization
         * @summary Create or update an organization
         * @param {UniversalOrganizationFormDefault} universalOrganizationFormDefault The form required to request this api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalV1OrganizationsPost: async (universalOrganizationFormDefault: UniversalOrganizationFormDefault, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'universalOrganizationFormDefault' is not null or undefined
            assertParamExists('internalV1OrganizationsPost', 'universalOrganizationFormDefault', universalOrganizationFormDefault)
            const localVarPath = `/internal/v1/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(universalOrganizationFormDefault, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authenticate with your email and password.
         * @summary Login with Email and Password
         * @param {LoginWithPasswordForm} loginWithPasswordForm Email and password form required for authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginPost: async (loginWithPasswordForm: LoginWithPasswordForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginWithPasswordForm' is not null or undefined
            assertParamExists('loginPost', 'loginWithPasswordForm', loginWithPasswordForm)
            const localVarPath = `/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginWithPasswordForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authenticate with App Authenticator.
         * @summary Login with App Authenticator
         * @param {LoginWithTwoFactorAuthAppForm} loginWithTwoFactorAuthAppForm Email and verificationCode form required for authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginTwoFactorAuthAppPost: async (loginWithTwoFactorAuthAppForm: LoginWithTwoFactorAuthAppForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginWithTwoFactorAuthAppForm' is not null or undefined
            assertParamExists('loginTwoFactorAuthAppPost', 'loginWithTwoFactorAuthAppForm', loginWithTwoFactorAuthAppForm)
            const localVarPath = `/login/two_factor_auth/app`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginWithTwoFactorAuthAppForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authenticate with Recovery Code.
         * @summary Login with Recovery Code
         * @param {LoginWithTwoFactorAuthRecoveryCodeForm} loginWithTwoFactorAuthRecoveryCodeForm Email and recoveryCode form required for authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginTwoFactorAuthRecoveryCodePost: async (loginWithTwoFactorAuthRecoveryCodeForm: LoginWithTwoFactorAuthRecoveryCodeForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginWithTwoFactorAuthRecoveryCodeForm' is not null or undefined
            assertParamExists('loginTwoFactorAuthRecoveryCodePost', 'loginWithTwoFactorAuthRecoveryCodeForm', loginWithTwoFactorAuthRecoveryCodeForm)
            const localVarPath = `/login/two_factor_auth/recovery_code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginWithTwoFactorAuthRecoveryCodeForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authenticate with Sms Authenticator.
         * @summary Login with Sms Authenticator
         * @param {LoginWithTwoFactorAuthSmsForm} loginWithTwoFactorAuthSmsForm Email and FirebaseIdToken form required for authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginTwoFactorAuthSmsPost: async (loginWithTwoFactorAuthSmsForm: LoginWithTwoFactorAuthSmsForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginWithTwoFactorAuthSmsForm' is not null or undefined
            assertParamExists('loginTwoFactorAuthSmsPost', 'loginWithTwoFactorAuthSmsForm', loginWithTwoFactorAuthSmsForm)
            const localVarPath = `/login/two_factor_auth/sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginWithTwoFactorAuthSmsForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Logout
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Make saml optional as a means of authenticating members of the organization
         * @summary Make saml optional
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeSamlOptional: async (organizationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('makeSamlOptional', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/saml/optional`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a SAML Response as an IDP for SAML SSO with Moneytree in the case of HTTP-POST binding.
         * @summary Returns a SAML Response as an IDP for SAML SSO.
         * @param {string} spid spid
         * @param {string} [spid2] 
         * @param {string} [relayState] 
         * @param {string} [sAMLRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRedirect: async (spid: string, spid2?: string, relayState?: string, sAMLRequest?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'spid' is not null or undefined
            assertParamExists('postRedirect', 'spid', spid)
            const localVarPath = `/v2/saml/redirect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication BearerToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (spid !== undefined) {
                localVarQueryParameter['spid'] = spid;
            }


            if (spid2 !== undefined) { 
                localVarFormParams.set('spid', spid2 as any);
            }
    
            if (relayState !== undefined) { 
                localVarFormParams.set('RelayState', relayState as any);
            }
    
            if (sAMLRequest !== undefined) { 
                localVarFormParams.set('SAMLRequest', sAMLRequest as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register two factor authentication with App Authenticator.
         * @summary Register two factor authentication with App
         * @param {RegisterAppAuthForm} registerAppAuthForm Form required for registering two factor authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTfaAppVerificationCode: async (registerAppAuthForm: RegisterAppAuthForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerAppAuthForm' is not null or undefined
            assertParamExists('registerTfaAppVerificationCode', 'registerAppAuthForm', registerAppAuthForm)
            const localVarPath = `/two_factor_auth/app/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerAppAuthForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register two factor authentication with SMS.
         * @summary Register two factor authentication with SMS
         * @param {RegisterSmsAuthForm} registerSmsAuthForm Form required for registering two factor authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTfaSmsAuth: async (registerSmsAuthForm: RegisterSmsAuthForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerSmsAuthForm' is not null or undefined
            assertParamExists('registerTfaSmsAuth', 'registerSmsAuthForm', registerSmsAuthForm)
            const localVarPath = `/two_factor_auth/sms/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerSmsAuthForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns valid login methods for organization and save saml redirect url
         * @summary Save Saml Redirect Url
         * @param {LoginOptionForm} loginOptionForm The form required to request this api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSamlRedirectUrl: async (loginOptionForm: LoginOptionForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginOptionForm' is not null or undefined
            assertParamExists('saveSamlRedirectUrl', 'loginOptionForm', loginOptionForm)
            const localVarPath = `/login/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginOptionForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get recovery codes for two factor authentication
         * @summary Get recovery codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorAuthAppGetRecoveryCodeGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/two_factor_auth/app/get_recovery_code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset two factor authentication
         * @summary Reset two factor authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorAuthReset: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/two_factor_auth/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update configuration for use with saml
         * @summary Update saml configuration
         * @param {number} organizationId 
         * @param {UpdateSamlConfigurationForm} updateSamlConfigurationForm The form required to request this api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSamlConfiguration: async (organizationId: number, updateSamlConfigurationForm: UpdateSamlConfigurationForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSamlConfiguration', 'organizationId', organizationId)
            // verify required parameter 'updateSamlConfigurationForm' is not null or undefined
            assertParamExists('updateSamlConfiguration', 'updateSamlConfigurationForm', updateSamlConfigurationForm)
            const localVarPath = `/organizations/{organizationId}/saml/configuration`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSamlConfigurationForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update configuration for use with scim
         * @summary Update scim configuration
         * @param {number} organizationId 
         * @param {UpdateScimConfigurationForm} updateScimConfigurationForm The form required to request this api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScimConfiguration: async (organizationId: number, updateScimConfigurationForm: UpdateScimConfigurationForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateScimConfiguration', 'organizationId', organizationId)
            // verify required parameter 'updateScimConfigurationForm' is not null or undefined
            assertParamExists('updateScimConfiguration', 'updateScimConfigurationForm', updateScimConfigurationForm)
            const localVarPath = `/organizations/{organizationId}/scim/configuration`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateScimConfigurationForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update password for specified user
         * @summary Update Password
         * @param {string} userId 
         * @param {UpdatePasswordForm} updatePasswordForm Form to update password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPassword: async (userId: string, updatePasswordForm: UpdatePasswordForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserPassword', 'userId', userId)
            // verify required parameter 'updatePasswordForm' is not null or undefined
            assertParamExists('updateUserPassword', 'updatePasswordForm', updatePasswordForm)
            const localVarPath = `/users/{userId}/password`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePasswordForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change temporary password to normal password for specified user
         * @summary Update Password from temporary
         * @param {string} userId 
         * @param {UpdateTempPasswordForm} updateTempPasswordForm Form to update temp password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserTempPassword: async (userId: string, updateTempPasswordForm: UpdateTempPasswordForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserTempPassword', 'userId', userId)
            // verify required parameter 'updateTempPasswordForm' is not null or undefined
            assertParamExists('updateUserTempPassword', 'updateTempPasswordForm', updateTempPasswordForm)
            const localVarPath = `/users/{userId}/update_temp_password`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTempPasswordForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check expiration of token for resetting password
         * @summary Check expiration of token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetCheckGet: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('usersPasswordResetCheckGet', 'token', token)
            const localVarPath = `/users/password_reset/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A password reset is executed
         * @summary Reset password confirmation
         * @param {PasswordResetConfirmationForm} passwordResetConfirmationForm Form required for resetting password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetConfirmPost: async (passwordResetConfirmationForm: PasswordResetConfirmationForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordResetConfirmationForm' is not null or undefined
            assertParamExists('usersPasswordResetConfirmPost', 'passwordResetConfirmationForm', passwordResetConfirmationForm)
            const localVarPath = `/users/password_reset/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordResetConfirmationForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * An email will be sent to you to reset your password
         * @summary Reset password
         * @param {PasswordResetForm} passwordResetForm Form required for resetting password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetPost: async (passwordResetForm: PasswordResetForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordResetForm' is not null or undefined
            assertParamExists('usersPasswordResetPost', 'passwordResetForm', passwordResetForm)
            const localVarPath = `/users/password_reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordResetForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify password reset with app
         * @summary Verify password reset with app
         * @param {PasswordResetAppVerificationForm} passwordResetAppVerificationForm Form required for resetting password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetTfaAppVerifyPost: async (passwordResetAppVerificationForm: PasswordResetAppVerificationForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordResetAppVerificationForm' is not null or undefined
            assertParamExists('usersPasswordResetTfaAppVerifyPost', 'passwordResetAppVerificationForm', passwordResetAppVerificationForm)
            const localVarPath = `/users/password_reset/tfa/app/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordResetAppVerificationForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify password reset with recovery code
         * @summary Verify password reset with recovery code
         * @param {PasswordResetRecoveryCodeForm} passwordResetRecoveryCodeForm Form required for resetting password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetTfaRecoveryCodePost: async (passwordResetRecoveryCodeForm: PasswordResetRecoveryCodeForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordResetRecoveryCodeForm' is not null or undefined
            assertParamExists('usersPasswordResetTfaRecoveryCodePost', 'passwordResetRecoveryCodeForm', passwordResetRecoveryCodeForm)
            const localVarPath = `/users/password_reset/tfa/recovery_code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordResetRecoveryCodeForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify password reset with sms
         * @summary Verify password reset with sms
         * @param {PasswordResetSmsVerificationForm} passwordResetSmsVerificationForm Form required for resetting password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetTfaSmsVerifyPost: async (passwordResetSmsVerificationForm: PasswordResetSmsVerificationForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordResetSmsVerificationForm' is not null or undefined
            assertParamExists('usersPasswordResetTfaSmsVerifyPost', 'passwordResetSmsVerificationForm', passwordResetSmsVerificationForm)
            const localVarPath = `/users/password_reset/tfa/sms/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordResetSmsVerificationForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * An email will be sent to you to reset two factor authentication for admin
         * @summary Send to reset two factor authentication for admin
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserIdTwoFactorAuthSendResetLinkAsAdminPost: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersUserIdTwoFactorAuthSendResetLinkAsAdminPost', 'userId', userId)
            const localVarPath = `/users/{userId}/two_factor_auth/send_reset_link_as_admin`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authenticate with your email and password
         * @summary Login with Email and Password for Universal Users
         * @param {LoginForm} loginForm Email and password form required for authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2LoginPost: async (loginForm: LoginForm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginForm' is not null or undefined
            assertParamExists('v2LoginPost', 'loginForm', loginForm)
            const localVarPath = `/v2/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate saml response that is receipt from IdP
         * @summary Validate saml response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSamlResponse: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/saml/assertion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifies a President Card JWT for SSO and then returns it in the response.
         * @summary Verifies a President Card JWT for SSO and then returns it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPcJwtSso: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/saml/jwtsso/pc/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify JWT.
         * @summary Verify ID Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTokenPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/verify/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieJwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Generate access token by grant code
         * @summary Generate access token
         * @param {GenerateAccessTokenForm} generateAccessTokenForm Form to generate access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accessTokenPost(generateAccessTokenForm: GenerateAccessTokenForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateAccessTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accessTokenPost(generateAccessTokenForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Check the phone number is not registered to anyone
         * @summary Check already registered phone number
         * @param {CheckAlreadyRegisteredPhoneNumberForm} checkAlreadyRegisteredPhoneNumberForm Form required for checking already registered phone number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkAlreadyRegisteredPhoneNumber(checkAlreadyRegisteredPhoneNumberForm: CheckAlreadyRegisteredPhoneNumberForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckAlreadyRegisteredPhoneNumberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkAlreadyRegisteredPhoneNumber(checkAlreadyRegisteredPhoneNumberForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete access token for use with scim
         * @summary Delete scim access token
         * @param {number} organizationId 
         * @param {string} accessTokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteScimAccessToken(organizationId: number, accessTokenId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteScimAccessToken(organizationId, accessTokenId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Disable saml as a means of authenticating members of the organization
         * @summary Disable saml
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableSaml(organizationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableSaml(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Disable scim for the organization
         * @summary Disable scim
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableScim(organizationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableScim(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Disable 2FA related to saml
         * @summary Disable two factor auth for saml
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableTwoFactorAuth(organizationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableTwoFactorAuth(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow the use of saml as a means of authenticating members of the organization
         * @summary Enable saml
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableSaml(organizationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableSaml(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Enable scim for the organization
         * @summary Enable scim
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableScim(organizationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableScim(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Enable 2FA related to saml
         * @summary Enable two factor auth for saml
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableTwoFactorAuth(organizationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableTwoFactorAuth(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Enforce saml as a means of authenticating members of the organization
         * @summary Enforce saml
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enforceSaml(organizationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enforceSaml(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Generate access token for use with scim
         * @summary Generate scim access token
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateScimAccessToken(organizationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScimJwtResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateScimAccessToken(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Generates a new JWT for SSO from recieved JWT and sets it to cookie.
         * @summary Sets a JWT for SSO to cookie.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJwtSso(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJwtSso(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns valid login methods for organization
         * @summary Get login options
         * @param {string} email 
         * @param {string} clientType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoginOptions(email: string, clientType: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SamlLoginOptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoginOptions(email, clientType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the metadata xml for SAML SSO of Moneytree.
         * @summary Returns the metadata xml.
         * @param {string} spid spid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMetadata(spid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMetadata(spid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Generates a new President Card JWT for SSO from recieved JWT and sets it to cookie.
         * @summary Sets a President Card JWT for SSO to the cookie.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPcJwtSso(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPcJwtSso(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get configuration for use with saml
         * @summary Get saml configuration
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSamlConfiguration(organizationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSamlConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSamlConfiguration(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get metadata
         * @summary Get saml metadata
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSamlMetadata(organizationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSamlMetadataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSamlMetadata(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get access token for use with scim
         * @summary Get scim access tokens
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScimAccessToken(organizationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetScimJwtsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScimAccessToken(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get configuration for use with scim
         * @summary Get scim configuration
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScimConfiguration(organizationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetScimConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScimConfiguration(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Generate QR Code for two factor authentication
         * @summary Generate QR Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTfaAppQrCode(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTfaAppQrCode(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download recovery code for two factor authentication
         * @summary Download recovery code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTfaAppRecoveryCode(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTfaAppRecoveryCode(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download recovery code for two factor authentication
         * @summary Download recovery code for SMS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTfaSmsRecoveryCode(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTfaSmsRecoveryCode(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Check application startup and retrieve running branch name and image hash.
         * @summary Health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Check if the user has access to the specified scope
         * @summary Access Scope Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalAccessCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves an access token for a given grant code or refresh token
         * @summary Retrieves an access token
         * @param {AccessTokenForm} accessTokenForm The form required to request this api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalV1AccessTokenPost(accessTokenForm: AccessTokenForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalV1AccessTokenPost(accessTokenForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create or update an organization
         * @summary Create or update an organization
         * @param {UniversalOrganizationFormDefault} universalOrganizationFormDefault The form required to request this api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalV1OrganizationsPost(universalOrganizationFormDefault: UniversalOrganizationFormDefault, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUniversalOrganizationResponseDefault>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalV1OrganizationsPost(universalOrganizationFormDefault, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Authenticate with your email and password.
         * @summary Login with Email and Password
         * @param {LoginWithPasswordForm} loginWithPasswordForm Email and password form required for authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginPost(loginWithPasswordForm: LoginWithPasswordForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginPost(loginWithPasswordForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Authenticate with App Authenticator.
         * @summary Login with App Authenticator
         * @param {LoginWithTwoFactorAuthAppForm} loginWithTwoFactorAuthAppForm Email and verificationCode form required for authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginTwoFactorAuthAppPost(loginWithTwoFactorAuthAppForm: LoginWithTwoFactorAuthAppForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginTwoFactorAuthAppPost(loginWithTwoFactorAuthAppForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Authenticate with Recovery Code.
         * @summary Login with Recovery Code
         * @param {LoginWithTwoFactorAuthRecoveryCodeForm} loginWithTwoFactorAuthRecoveryCodeForm Email and recoveryCode form required for authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginTwoFactorAuthRecoveryCodePost(loginWithTwoFactorAuthRecoveryCodeForm: LoginWithTwoFactorAuthRecoveryCodeForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginTwoFactorAuthRecoveryCodePost(loginWithTwoFactorAuthRecoveryCodeForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Authenticate with Sms Authenticator.
         * @summary Login with Sms Authenticator
         * @param {LoginWithTwoFactorAuthSmsForm} loginWithTwoFactorAuthSmsForm Email and FirebaseIdToken form required for authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginTwoFactorAuthSmsPost(loginWithTwoFactorAuthSmsForm: LoginWithTwoFactorAuthSmsForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginTwoFactorAuthSmsPost(loginWithTwoFactorAuthSmsForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Logout
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logoutPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logoutPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Make saml optional as a means of authenticating members of the organization
         * @summary Make saml optional
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async makeSamlOptional(organizationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.makeSamlOptional(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a SAML Response as an IDP for SAML SSO with Moneytree in the case of HTTP-POST binding.
         * @summary Returns a SAML Response as an IDP for SAML SSO.
         * @param {string} spid spid
         * @param {string} [spid2] 
         * @param {string} [relayState] 
         * @param {string} [sAMLRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRedirect(spid: string, spid2?: string, relayState?: string, sAMLRequest?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRedirect(spid, spid2, relayState, sAMLRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Register two factor authentication with App Authenticator.
         * @summary Register two factor authentication with App
         * @param {RegisterAppAuthForm} registerAppAuthForm Form required for registering two factor authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerTfaAppVerificationCode(registerAppAuthForm: RegisterAppAuthForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TwoFactorAuthRegistrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerTfaAppVerificationCode(registerAppAuthForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Register two factor authentication with SMS.
         * @summary Register two factor authentication with SMS
         * @param {RegisterSmsAuthForm} registerSmsAuthForm Form required for registering two factor authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerTfaSmsAuth(registerSmsAuthForm: RegisterSmsAuthForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TwoFactorAuthRegistrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerTfaSmsAuth(registerSmsAuthForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns valid login methods for organization and save saml redirect url
         * @summary Save Saml Redirect Url
         * @param {LoginOptionForm} loginOptionForm The form required to request this api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSamlRedirectUrl(loginOptionForm: LoginOptionForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SamlLoginOptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSamlRedirectUrl(loginOptionForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get recovery codes for two factor authentication
         * @summary Get recovery codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async twoFactorAuthAppGetRecoveryCodeGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.twoFactorAuthAppGetRecoveryCodeGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Reset two factor authentication
         * @summary Reset two factor authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async twoFactorAuthReset(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.twoFactorAuthReset(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update configuration for use with saml
         * @summary Update saml configuration
         * @param {number} organizationId 
         * @param {UpdateSamlConfigurationForm} updateSamlConfigurationForm The form required to request this api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSamlConfiguration(organizationId: number, updateSamlConfigurationForm: UpdateSamlConfigurationForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSamlConfiguration(organizationId, updateSamlConfigurationForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update configuration for use with scim
         * @summary Update scim configuration
         * @param {number} organizationId 
         * @param {UpdateScimConfigurationForm} updateScimConfigurationForm The form required to request this api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateScimConfiguration(organizationId: number, updateScimConfigurationForm: UpdateScimConfigurationForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateScimConfiguration(organizationId, updateScimConfigurationForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update password for specified user
         * @summary Update Password
         * @param {string} userId 
         * @param {UpdatePasswordForm} updatePasswordForm Form to update password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPassword(userId: string, updatePasswordForm: UpdatePasswordForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPassword(userId, updatePasswordForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Change temporary password to normal password for specified user
         * @summary Update Password from temporary
         * @param {string} userId 
         * @param {UpdateTempPasswordForm} updateTempPasswordForm Form to update temp password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserTempPassword(userId: string, updateTempPasswordForm: UpdateTempPasswordForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserTempPassword(userId, updateTempPasswordForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Check expiration of token for resetting password
         * @summary Check expiration of token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersPasswordResetCheckGet(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordResetTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersPasswordResetCheckGet(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * A password reset is executed
         * @summary Reset password confirmation
         * @param {PasswordResetConfirmationForm} passwordResetConfirmationForm Form required for resetting password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersPasswordResetConfirmPost(passwordResetConfirmationForm: PasswordResetConfirmationForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersPasswordResetConfirmPost(passwordResetConfirmationForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * An email will be sent to you to reset your password
         * @summary Reset password
         * @param {PasswordResetForm} passwordResetForm Form required for resetting password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersPasswordResetPost(passwordResetForm: PasswordResetForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersPasswordResetPost(passwordResetForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verify password reset with app
         * @summary Verify password reset with app
         * @param {PasswordResetAppVerificationForm} passwordResetAppVerificationForm Form required for resetting password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersPasswordResetTfaAppVerifyPost(passwordResetAppVerificationForm: PasswordResetAppVerificationForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordResetVerificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersPasswordResetTfaAppVerifyPost(passwordResetAppVerificationForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verify password reset with recovery code
         * @summary Verify password reset with recovery code
         * @param {PasswordResetRecoveryCodeForm} passwordResetRecoveryCodeForm Form required for resetting password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersPasswordResetTfaRecoveryCodePost(passwordResetRecoveryCodeForm: PasswordResetRecoveryCodeForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordResetVerificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersPasswordResetTfaRecoveryCodePost(passwordResetRecoveryCodeForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verify password reset with sms
         * @summary Verify password reset with sms
         * @param {PasswordResetSmsVerificationForm} passwordResetSmsVerificationForm Form required for resetting password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersPasswordResetTfaSmsVerifyPost(passwordResetSmsVerificationForm: PasswordResetSmsVerificationForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordResetVerificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersPasswordResetTfaSmsVerifyPost(passwordResetSmsVerificationForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * An email will be sent to you to reset two factor authentication for admin
         * @summary Send to reset two factor authentication for admin
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersUserIdTwoFactorAuthSendResetLinkAsAdminPost(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersUserIdTwoFactorAuthSendResetLinkAsAdminPost(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Authenticate with your email and password
         * @summary Login with Email and Password for Universal Users
         * @param {LoginForm} loginForm Email and password form required for authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2LoginPost(loginForm: LoginForm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2LoginPost(loginForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Validate saml response that is receipt from IdP
         * @summary Validate saml response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateSamlResponse(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateSamlResponse(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verifies a President Card JWT for SSO and then returns it in the response.
         * @summary Verifies a President Card JWT for SSO and then returns it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyPcJwtSso(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JWTSSOPCVerifyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyPcJwtSso(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verify JWT.
         * @summary Verify ID Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyTokenPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationClaimResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyTokenPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Generate access token by grant code
         * @summary Generate access token
         * @param {DefaultApiAccessTokenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessTokenPost(requestParameters: DefaultApiAccessTokenPostRequest, options?: AxiosRequestConfig): AxiosPromise<GenerateAccessTokenResponse> {
            return localVarFp.accessTokenPost(requestParameters.generateAccessTokenForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Check the phone number is not registered to anyone
         * @summary Check already registered phone number
         * @param {DefaultApiCheckAlreadyRegisteredPhoneNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAlreadyRegisteredPhoneNumber(requestParameters: DefaultApiCheckAlreadyRegisteredPhoneNumberRequest, options?: AxiosRequestConfig): AxiosPromise<CheckAlreadyRegisteredPhoneNumberResponse> {
            return localVarFp.checkAlreadyRegisteredPhoneNumber(requestParameters.checkAlreadyRegisteredPhoneNumberForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete access token for use with scim
         * @summary Delete scim access token
         * @param {DefaultApiDeleteScimAccessTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScimAccessToken(requestParameters: DefaultApiDeleteScimAccessTokenRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteScimAccessToken(requestParameters.organizationId, requestParameters.accessTokenId, options).then((request) => request(axios, basePath));
        },
        /**
         * Disable saml as a means of authenticating members of the organization
         * @summary Disable saml
         * @param {DefaultApiDisableSamlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableSaml(requestParameters: DefaultApiDisableSamlRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.disableSaml(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Disable scim for the organization
         * @summary Disable scim
         * @param {DefaultApiDisableScimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableScim(requestParameters: DefaultApiDisableScimRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.disableScim(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Disable 2FA related to saml
         * @summary Disable two factor auth for saml
         * @param {DefaultApiDisableTwoFactorAuthRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableTwoFactorAuth(requestParameters: DefaultApiDisableTwoFactorAuthRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.disableTwoFactorAuth(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow the use of saml as a means of authenticating members of the organization
         * @summary Enable saml
         * @param {DefaultApiEnableSamlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableSaml(requestParameters: DefaultApiEnableSamlRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enableSaml(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable scim for the organization
         * @summary Enable scim
         * @param {DefaultApiEnableScimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableScim(requestParameters: DefaultApiEnableScimRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enableScim(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable 2FA related to saml
         * @summary Enable two factor auth for saml
         * @param {DefaultApiEnableTwoFactorAuthRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableTwoFactorAuth(requestParameters: DefaultApiEnableTwoFactorAuthRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enableTwoFactorAuth(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Enforce saml as a means of authenticating members of the organization
         * @summary Enforce saml
         * @param {DefaultApiEnforceSamlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enforceSaml(requestParameters: DefaultApiEnforceSamlRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enforceSaml(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate access token for use with scim
         * @summary Generate scim access token
         * @param {DefaultApiGenerateScimAccessTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateScimAccessToken(requestParameters: DefaultApiGenerateScimAccessTokenRequest, options?: AxiosRequestConfig): AxiosPromise<ScimJwtResponse> {
            return localVarFp.generateScimAccessToken(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a new JWT for SSO from recieved JWT and sets it to cookie.
         * @summary Sets a JWT for SSO to cookie.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJwtSso(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getJwtSso(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns valid login methods for organization
         * @summary Get login options
         * @param {DefaultApiGetLoginOptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoginOptions(requestParameters: DefaultApiGetLoginOptionsRequest, options?: AxiosRequestConfig): AxiosPromise<SamlLoginOptionResponse> {
            return localVarFp.getLoginOptions(requestParameters.email, requestParameters.clientType, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the metadata xml for SAML SSO of Moneytree.
         * @summary Returns the metadata xml.
         * @param {DefaultApiGetMetadataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetadata(requestParameters: DefaultApiGetMetadataRequest, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getMetadata(requestParameters.spid, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a new President Card JWT for SSO from recieved JWT and sets it to cookie.
         * @summary Sets a President Card JWT for SSO to the cookie.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPcJwtSso(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getPcJwtSso(options).then((request) => request(axios, basePath));
        },
        /**
         * Get configuration for use with saml
         * @summary Get saml configuration
         * @param {DefaultApiGetSamlConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamlConfiguration(requestParameters: DefaultApiGetSamlConfigurationRequest, options?: AxiosRequestConfig): AxiosPromise<GetSamlConfigurationResponse> {
            return localVarFp.getSamlConfiguration(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get metadata
         * @summary Get saml metadata
         * @param {DefaultApiGetSamlMetadataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamlMetadata(requestParameters: DefaultApiGetSamlMetadataRequest, options?: AxiosRequestConfig): AxiosPromise<GetSamlMetadataResponse> {
            return localVarFp.getSamlMetadata(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get access token for use with scim
         * @summary Get scim access tokens
         * @param {DefaultApiGetScimAccessTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScimAccessToken(requestParameters: DefaultApiGetScimAccessTokenRequest, options?: AxiosRequestConfig): AxiosPromise<GetScimJwtsResponse> {
            return localVarFp.getScimAccessToken(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get configuration for use with scim
         * @summary Get scim configuration
         * @param {DefaultApiGetScimConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScimConfiguration(requestParameters: DefaultApiGetScimConfigurationRequest, options?: AxiosRequestConfig): AxiosPromise<GetScimConfigurationResponse> {
            return localVarFp.getScimConfiguration(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate QR Code for two factor authentication
         * @summary Generate QR Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaAppQrCode(options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getTfaAppQrCode(options).then((request) => request(axios, basePath));
        },
        /**
         * Download recovery code for two factor authentication
         * @summary Download recovery code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaAppRecoveryCode(options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getTfaAppRecoveryCode(options).then((request) => request(axios, basePath));
        },
        /**
         * Download recovery code for two factor authentication
         * @summary Download recovery code for SMS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaSmsRecoveryCode(options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getTfaSmsRecoveryCode(options).then((request) => request(axios, basePath));
        },
        /**
         * Check application startup and retrieve running branch name and image hash.
         * @summary Health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckGet(options?: AxiosRequestConfig): AxiosPromise<BuildConfigResponse> {
            return localVarFp.healthCheckGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Check if the user has access to the specified scope
         * @summary Access Scope Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalGet(options?: AxiosRequestConfig): AxiosPromise<InternalAccessCheckResponse> {
            return localVarFp.internalGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves an access token for a given grant code or refresh token
         * @summary Retrieves an access token
         * @param {DefaultApiInternalV1AccessTokenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalV1AccessTokenPost(requestParameters: DefaultApiInternalV1AccessTokenPostRequest, options?: AxiosRequestConfig): AxiosPromise<AccessTokenResponse> {
            return localVarFp.internalV1AccessTokenPost(requestParameters.accessTokenForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Create or update an organization
         * @summary Create or update an organization
         * @param {DefaultApiInternalV1OrganizationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalV1OrganizationsPost(requestParameters: DefaultApiInternalV1OrganizationsPostRequest, options?: AxiosRequestConfig): AxiosPromise<CreateUniversalOrganizationResponseDefault> {
            return localVarFp.internalV1OrganizationsPost(requestParameters.universalOrganizationFormDefault, options).then((request) => request(axios, basePath));
        },
        /**
         * Authenticate with your email and password.
         * @summary Login with Email and Password
         * @param {DefaultApiLoginPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginPost(requestParameters: DefaultApiLoginPostRequest, options?: AxiosRequestConfig): AxiosPromise<AuthenticationResponse> {
            return localVarFp.loginPost(requestParameters.loginWithPasswordForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Authenticate with App Authenticator.
         * @summary Login with App Authenticator
         * @param {DefaultApiLoginTwoFactorAuthAppPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginTwoFactorAuthAppPost(requestParameters: DefaultApiLoginTwoFactorAuthAppPostRequest, options?: AxiosRequestConfig): AxiosPromise<AuthenticationResponse> {
            return localVarFp.loginTwoFactorAuthAppPost(requestParameters.loginWithTwoFactorAuthAppForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Authenticate with Recovery Code.
         * @summary Login with Recovery Code
         * @param {DefaultApiLoginTwoFactorAuthRecoveryCodePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginTwoFactorAuthRecoveryCodePost(requestParameters: DefaultApiLoginTwoFactorAuthRecoveryCodePostRequest, options?: AxiosRequestConfig): AxiosPromise<AuthenticationResponse> {
            return localVarFp.loginTwoFactorAuthRecoveryCodePost(requestParameters.loginWithTwoFactorAuthRecoveryCodeForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Authenticate with Sms Authenticator.
         * @summary Login with Sms Authenticator
         * @param {DefaultApiLoginTwoFactorAuthSmsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginTwoFactorAuthSmsPost(requestParameters: DefaultApiLoginTwoFactorAuthSmsPostRequest, options?: AxiosRequestConfig): AxiosPromise<AuthenticationResponse> {
            return localVarFp.loginTwoFactorAuthSmsPost(requestParameters.loginWithTwoFactorAuthSmsForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Logout
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutPost(options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.logoutPost(options).then((request) => request(axios, basePath));
        },
        /**
         * Make saml optional as a means of authenticating members of the organization
         * @summary Make saml optional
         * @param {DefaultApiMakeSamlOptionalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeSamlOptional(requestParameters: DefaultApiMakeSamlOptionalRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.makeSamlOptional(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a SAML Response as an IDP for SAML SSO with Moneytree in the case of HTTP-POST binding.
         * @summary Returns a SAML Response as an IDP for SAML SSO.
         * @param {DefaultApiPostRedirectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRedirect(requestParameters: DefaultApiPostRedirectRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postRedirect(requestParameters.spid, requestParameters.spid2, requestParameters.relayState, requestParameters.sAMLRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Register two factor authentication with App Authenticator.
         * @summary Register two factor authentication with App
         * @param {DefaultApiRegisterTfaAppVerificationCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTfaAppVerificationCode(requestParameters: DefaultApiRegisterTfaAppVerificationCodeRequest, options?: AxiosRequestConfig): AxiosPromise<TwoFactorAuthRegistrationResponse> {
            return localVarFp.registerTfaAppVerificationCode(requestParameters.registerAppAuthForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Register two factor authentication with SMS.
         * @summary Register two factor authentication with SMS
         * @param {DefaultApiRegisterTfaSmsAuthRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTfaSmsAuth(requestParameters: DefaultApiRegisterTfaSmsAuthRequest, options?: AxiosRequestConfig): AxiosPromise<TwoFactorAuthRegistrationResponse> {
            return localVarFp.registerTfaSmsAuth(requestParameters.registerSmsAuthForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns valid login methods for organization and save saml redirect url
         * @summary Save Saml Redirect Url
         * @param {DefaultApiSaveSamlRedirectUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSamlRedirectUrl(requestParameters: DefaultApiSaveSamlRedirectUrlRequest, options?: AxiosRequestConfig): AxiosPromise<SamlLoginOptionResponse> {
            return localVarFp.saveSamlRedirectUrl(requestParameters.loginOptionForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Get recovery codes for two factor authentication
         * @summary Get recovery codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorAuthAppGetRecoveryCodeGet(options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.twoFactorAuthAppGetRecoveryCodeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Reset two factor authentication
         * @summary Reset two factor authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorAuthReset(options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.twoFactorAuthReset(options).then((request) => request(axios, basePath));
        },
        /**
         * Update configuration for use with saml
         * @summary Update saml configuration
         * @param {DefaultApiUpdateSamlConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSamlConfiguration(requestParameters: DefaultApiUpdateSamlConfigurationRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateSamlConfiguration(requestParameters.organizationId, requestParameters.updateSamlConfigurationForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Update configuration for use with scim
         * @summary Update scim configuration
         * @param {DefaultApiUpdateScimConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScimConfiguration(requestParameters: DefaultApiUpdateScimConfigurationRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateScimConfiguration(requestParameters.organizationId, requestParameters.updateScimConfigurationForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Update password for specified user
         * @summary Update Password
         * @param {DefaultApiUpdateUserPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPassword(requestParameters: DefaultApiUpdateUserPasswordRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateUserPassword(requestParameters.userId, requestParameters.updatePasswordForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Change temporary password to normal password for specified user
         * @summary Update Password from temporary
         * @param {DefaultApiUpdateUserTempPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserTempPassword(requestParameters: DefaultApiUpdateUserTempPasswordRequest, options?: AxiosRequestConfig): AxiosPromise<AuthenticationResponse> {
            return localVarFp.updateUserTempPassword(requestParameters.userId, requestParameters.updateTempPasswordForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Check expiration of token for resetting password
         * @summary Check expiration of token
         * @param {DefaultApiUsersPasswordResetCheckGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetCheckGet(requestParameters: DefaultApiUsersPasswordResetCheckGetRequest, options?: AxiosRequestConfig): AxiosPromise<PasswordResetTokenResponse> {
            return localVarFp.usersPasswordResetCheckGet(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * A password reset is executed
         * @summary Reset password confirmation
         * @param {DefaultApiUsersPasswordResetConfirmPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetConfirmPost(requestParameters: DefaultApiUsersPasswordResetConfirmPostRequest, options?: AxiosRequestConfig): AxiosPromise<AuthenticationResponse> {
            return localVarFp.usersPasswordResetConfirmPost(requestParameters.passwordResetConfirmationForm, options).then((request) => request(axios, basePath));
        },
        /**
         * An email will be sent to you to reset your password
         * @summary Reset password
         * @param {DefaultApiUsersPasswordResetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetPost(requestParameters: DefaultApiUsersPasswordResetPostRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.usersPasswordResetPost(requestParameters.passwordResetForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Verify password reset with app
         * @summary Verify password reset with app
         * @param {DefaultApiUsersPasswordResetTfaAppVerifyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetTfaAppVerifyPost(requestParameters: DefaultApiUsersPasswordResetTfaAppVerifyPostRequest, options?: AxiosRequestConfig): AxiosPromise<PasswordResetVerificationResponse> {
            return localVarFp.usersPasswordResetTfaAppVerifyPost(requestParameters.passwordResetAppVerificationForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Verify password reset with recovery code
         * @summary Verify password reset with recovery code
         * @param {DefaultApiUsersPasswordResetTfaRecoveryCodePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetTfaRecoveryCodePost(requestParameters: DefaultApiUsersPasswordResetTfaRecoveryCodePostRequest, options?: AxiosRequestConfig): AxiosPromise<PasswordResetVerificationResponse> {
            return localVarFp.usersPasswordResetTfaRecoveryCodePost(requestParameters.passwordResetRecoveryCodeForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Verify password reset with sms
         * @summary Verify password reset with sms
         * @param {DefaultApiUsersPasswordResetTfaSmsVerifyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetTfaSmsVerifyPost(requestParameters: DefaultApiUsersPasswordResetTfaSmsVerifyPostRequest, options?: AxiosRequestConfig): AxiosPromise<PasswordResetVerificationResponse> {
            return localVarFp.usersPasswordResetTfaSmsVerifyPost(requestParameters.passwordResetSmsVerificationForm, options).then((request) => request(axios, basePath));
        },
        /**
         * An email will be sent to you to reset two factor authentication for admin
         * @summary Send to reset two factor authentication for admin
         * @param {DefaultApiUsersUserIdTwoFactorAuthSendResetLinkAsAdminPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserIdTwoFactorAuthSendResetLinkAsAdminPost(requestParameters: DefaultApiUsersUserIdTwoFactorAuthSendResetLinkAsAdminPostRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.usersUserIdTwoFactorAuthSendResetLinkAsAdminPost(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Authenticate with your email and password
         * @summary Login with Email and Password for Universal Users
         * @param {DefaultApiV2LoginPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2LoginPost(requestParameters: DefaultApiV2LoginPostRequest, options?: AxiosRequestConfig): AxiosPromise<LoginResponse> {
            return localVarFp.v2LoginPost(requestParameters.loginForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate saml response that is receipt from IdP
         * @summary Validate saml response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSamlResponse(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.validateSamlResponse(options).then((request) => request(axios, basePath));
        },
        /**
         * Verifies a President Card JWT for SSO and then returns it in the response.
         * @summary Verifies a President Card JWT for SSO and then returns it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPcJwtSso(options?: AxiosRequestConfig): AxiosPromise<JWTSSOPCVerifyResponse> {
            return localVarFp.verifyPcJwtSso(options).then((request) => request(axios, basePath));
        },
        /**
         * Verify JWT.
         * @summary Verify ID Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTokenPost(options?: AxiosRequestConfig): AxiosPromise<AuthenticationClaimResponse> {
            return localVarFp.verifyTokenPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for accessTokenPost operation in DefaultApi.
 * @export
 * @interface DefaultApiAccessTokenPostRequest
 */
export interface DefaultApiAccessTokenPostRequest {
    /**
     * Form to generate access token
     * @type {GenerateAccessTokenForm}
     * @memberof DefaultApiAccessTokenPost
     */
    readonly generateAccessTokenForm: GenerateAccessTokenForm
}

/**
 * Request parameters for checkAlreadyRegisteredPhoneNumber operation in DefaultApi.
 * @export
 * @interface DefaultApiCheckAlreadyRegisteredPhoneNumberRequest
 */
export interface DefaultApiCheckAlreadyRegisteredPhoneNumberRequest {
    /**
     * Form required for checking already registered phone number
     * @type {CheckAlreadyRegisteredPhoneNumberForm}
     * @memberof DefaultApiCheckAlreadyRegisteredPhoneNumber
     */
    readonly checkAlreadyRegisteredPhoneNumberForm: CheckAlreadyRegisteredPhoneNumberForm
}

/**
 * Request parameters for deleteScimAccessToken operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteScimAccessTokenRequest
 */
export interface DefaultApiDeleteScimAccessTokenRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDeleteScimAccessToken
     */
    readonly organizationId: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteScimAccessToken
     */
    readonly accessTokenId: string
}

/**
 * Request parameters for disableSaml operation in DefaultApi.
 * @export
 * @interface DefaultApiDisableSamlRequest
 */
export interface DefaultApiDisableSamlRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDisableSaml
     */
    readonly organizationId: number
}

/**
 * Request parameters for disableScim operation in DefaultApi.
 * @export
 * @interface DefaultApiDisableScimRequest
 */
export interface DefaultApiDisableScimRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDisableScim
     */
    readonly organizationId: number
}

/**
 * Request parameters for disableTwoFactorAuth operation in DefaultApi.
 * @export
 * @interface DefaultApiDisableTwoFactorAuthRequest
 */
export interface DefaultApiDisableTwoFactorAuthRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDisableTwoFactorAuth
     */
    readonly organizationId: number
}

/**
 * Request parameters for enableSaml operation in DefaultApi.
 * @export
 * @interface DefaultApiEnableSamlRequest
 */
export interface DefaultApiEnableSamlRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiEnableSaml
     */
    readonly organizationId: number
}

/**
 * Request parameters for enableScim operation in DefaultApi.
 * @export
 * @interface DefaultApiEnableScimRequest
 */
export interface DefaultApiEnableScimRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiEnableScim
     */
    readonly organizationId: number
}

/**
 * Request parameters for enableTwoFactorAuth operation in DefaultApi.
 * @export
 * @interface DefaultApiEnableTwoFactorAuthRequest
 */
export interface DefaultApiEnableTwoFactorAuthRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiEnableTwoFactorAuth
     */
    readonly organizationId: number
}

/**
 * Request parameters for enforceSaml operation in DefaultApi.
 * @export
 * @interface DefaultApiEnforceSamlRequest
 */
export interface DefaultApiEnforceSamlRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiEnforceSaml
     */
    readonly organizationId: number
}

/**
 * Request parameters for generateScimAccessToken operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateScimAccessTokenRequest
 */
export interface DefaultApiGenerateScimAccessTokenRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGenerateScimAccessToken
     */
    readonly organizationId: number
}

/**
 * Request parameters for getLoginOptions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLoginOptionsRequest
 */
export interface DefaultApiGetLoginOptionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLoginOptions
     */
    readonly email: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLoginOptions
     */
    readonly clientType: string
}

/**
 * Request parameters for getMetadata operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMetadataRequest
 */
export interface DefaultApiGetMetadataRequest {
    /**
     * spid
     * @type {string}
     * @memberof DefaultApiGetMetadata
     */
    readonly spid: string
}

/**
 * Request parameters for getSamlConfiguration operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSamlConfigurationRequest
 */
export interface DefaultApiGetSamlConfigurationRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetSamlConfiguration
     */
    readonly organizationId: number
}

/**
 * Request parameters for getSamlMetadata operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSamlMetadataRequest
 */
export interface DefaultApiGetSamlMetadataRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetSamlMetadata
     */
    readonly organizationId: number
}

/**
 * Request parameters for getScimAccessToken operation in DefaultApi.
 * @export
 * @interface DefaultApiGetScimAccessTokenRequest
 */
export interface DefaultApiGetScimAccessTokenRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetScimAccessToken
     */
    readonly organizationId: number
}

/**
 * Request parameters for getScimConfiguration operation in DefaultApi.
 * @export
 * @interface DefaultApiGetScimConfigurationRequest
 */
export interface DefaultApiGetScimConfigurationRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetScimConfiguration
     */
    readonly organizationId: number
}

/**
 * Request parameters for internalV1AccessTokenPost operation in DefaultApi.
 * @export
 * @interface DefaultApiInternalV1AccessTokenPostRequest
 */
export interface DefaultApiInternalV1AccessTokenPostRequest {
    /**
     * The form required to request this api
     * @type {AccessTokenForm}
     * @memberof DefaultApiInternalV1AccessTokenPost
     */
    readonly accessTokenForm: AccessTokenForm
}

/**
 * Request parameters for internalV1OrganizationsPost operation in DefaultApi.
 * @export
 * @interface DefaultApiInternalV1OrganizationsPostRequest
 */
export interface DefaultApiInternalV1OrganizationsPostRequest {
    /**
     * The form required to request this api
     * @type {UniversalOrganizationFormDefault}
     * @memberof DefaultApiInternalV1OrganizationsPost
     */
    readonly universalOrganizationFormDefault: UniversalOrganizationFormDefault
}

/**
 * Request parameters for loginPost operation in DefaultApi.
 * @export
 * @interface DefaultApiLoginPostRequest
 */
export interface DefaultApiLoginPostRequest {
    /**
     * Email and password form required for authentication
     * @type {LoginWithPasswordForm}
     * @memberof DefaultApiLoginPost
     */
    readonly loginWithPasswordForm: LoginWithPasswordForm
}

/**
 * Request parameters for loginTwoFactorAuthAppPost operation in DefaultApi.
 * @export
 * @interface DefaultApiLoginTwoFactorAuthAppPostRequest
 */
export interface DefaultApiLoginTwoFactorAuthAppPostRequest {
    /**
     * Email and verificationCode form required for authentication
     * @type {LoginWithTwoFactorAuthAppForm}
     * @memberof DefaultApiLoginTwoFactorAuthAppPost
     */
    readonly loginWithTwoFactorAuthAppForm: LoginWithTwoFactorAuthAppForm
}

/**
 * Request parameters for loginTwoFactorAuthRecoveryCodePost operation in DefaultApi.
 * @export
 * @interface DefaultApiLoginTwoFactorAuthRecoveryCodePostRequest
 */
export interface DefaultApiLoginTwoFactorAuthRecoveryCodePostRequest {
    /**
     * Email and recoveryCode form required for authentication
     * @type {LoginWithTwoFactorAuthRecoveryCodeForm}
     * @memberof DefaultApiLoginTwoFactorAuthRecoveryCodePost
     */
    readonly loginWithTwoFactorAuthRecoveryCodeForm: LoginWithTwoFactorAuthRecoveryCodeForm
}

/**
 * Request parameters for loginTwoFactorAuthSmsPost operation in DefaultApi.
 * @export
 * @interface DefaultApiLoginTwoFactorAuthSmsPostRequest
 */
export interface DefaultApiLoginTwoFactorAuthSmsPostRequest {
    /**
     * Email and FirebaseIdToken form required for authentication
     * @type {LoginWithTwoFactorAuthSmsForm}
     * @memberof DefaultApiLoginTwoFactorAuthSmsPost
     */
    readonly loginWithTwoFactorAuthSmsForm: LoginWithTwoFactorAuthSmsForm
}

/**
 * Request parameters for makeSamlOptional operation in DefaultApi.
 * @export
 * @interface DefaultApiMakeSamlOptionalRequest
 */
export interface DefaultApiMakeSamlOptionalRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiMakeSamlOptional
     */
    readonly organizationId: number
}

/**
 * Request parameters for postRedirect operation in DefaultApi.
 * @export
 * @interface DefaultApiPostRedirectRequest
 */
export interface DefaultApiPostRedirectRequest {
    /**
     * spid
     * @type {string}
     * @memberof DefaultApiPostRedirect
     */
    readonly spid: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostRedirect
     */
    readonly spid2?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostRedirect
     */
    readonly relayState?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostRedirect
     */
    readonly sAMLRequest?: string
}

/**
 * Request parameters for registerTfaAppVerificationCode operation in DefaultApi.
 * @export
 * @interface DefaultApiRegisterTfaAppVerificationCodeRequest
 */
export interface DefaultApiRegisterTfaAppVerificationCodeRequest {
    /**
     * Form required for registering two factor authentication
     * @type {RegisterAppAuthForm}
     * @memberof DefaultApiRegisterTfaAppVerificationCode
     */
    readonly registerAppAuthForm: RegisterAppAuthForm
}

/**
 * Request parameters for registerTfaSmsAuth operation in DefaultApi.
 * @export
 * @interface DefaultApiRegisterTfaSmsAuthRequest
 */
export interface DefaultApiRegisterTfaSmsAuthRequest {
    /**
     * Form required for registering two factor authentication
     * @type {RegisterSmsAuthForm}
     * @memberof DefaultApiRegisterTfaSmsAuth
     */
    readonly registerSmsAuthForm: RegisterSmsAuthForm
}

/**
 * Request parameters for saveSamlRedirectUrl operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveSamlRedirectUrlRequest
 */
export interface DefaultApiSaveSamlRedirectUrlRequest {
    /**
     * The form required to request this api
     * @type {LoginOptionForm}
     * @memberof DefaultApiSaveSamlRedirectUrl
     */
    readonly loginOptionForm: LoginOptionForm
}

/**
 * Request parameters for updateSamlConfiguration operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateSamlConfigurationRequest
 */
export interface DefaultApiUpdateSamlConfigurationRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateSamlConfiguration
     */
    readonly organizationId: number

    /**
     * The form required to request this api
     * @type {UpdateSamlConfigurationForm}
     * @memberof DefaultApiUpdateSamlConfiguration
     */
    readonly updateSamlConfigurationForm: UpdateSamlConfigurationForm
}

/**
 * Request parameters for updateScimConfiguration operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateScimConfigurationRequest
 */
export interface DefaultApiUpdateScimConfigurationRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateScimConfiguration
     */
    readonly organizationId: number

    /**
     * The form required to request this api
     * @type {UpdateScimConfigurationForm}
     * @memberof DefaultApiUpdateScimConfiguration
     */
    readonly updateScimConfigurationForm: UpdateScimConfigurationForm
}

/**
 * Request parameters for updateUserPassword operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserPasswordRequest
 */
export interface DefaultApiUpdateUserPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserPassword
     */
    readonly userId: string

    /**
     * Form to update password
     * @type {UpdatePasswordForm}
     * @memberof DefaultApiUpdateUserPassword
     */
    readonly updatePasswordForm: UpdatePasswordForm
}

/**
 * Request parameters for updateUserTempPassword operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserTempPasswordRequest
 */
export interface DefaultApiUpdateUserTempPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserTempPassword
     */
    readonly userId: string

    /**
     * Form to update temp password
     * @type {UpdateTempPasswordForm}
     * @memberof DefaultApiUpdateUserTempPassword
     */
    readonly updateTempPasswordForm: UpdateTempPasswordForm
}

/**
 * Request parameters for usersPasswordResetCheckGet operation in DefaultApi.
 * @export
 * @interface DefaultApiUsersPasswordResetCheckGetRequest
 */
export interface DefaultApiUsersPasswordResetCheckGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUsersPasswordResetCheckGet
     */
    readonly token: string
}

/**
 * Request parameters for usersPasswordResetConfirmPost operation in DefaultApi.
 * @export
 * @interface DefaultApiUsersPasswordResetConfirmPostRequest
 */
export interface DefaultApiUsersPasswordResetConfirmPostRequest {
    /**
     * Form required for resetting password
     * @type {PasswordResetConfirmationForm}
     * @memberof DefaultApiUsersPasswordResetConfirmPost
     */
    readonly passwordResetConfirmationForm: PasswordResetConfirmationForm
}

/**
 * Request parameters for usersPasswordResetPost operation in DefaultApi.
 * @export
 * @interface DefaultApiUsersPasswordResetPostRequest
 */
export interface DefaultApiUsersPasswordResetPostRequest {
    /**
     * Form required for resetting password
     * @type {PasswordResetForm}
     * @memberof DefaultApiUsersPasswordResetPost
     */
    readonly passwordResetForm: PasswordResetForm
}

/**
 * Request parameters for usersPasswordResetTfaAppVerifyPost operation in DefaultApi.
 * @export
 * @interface DefaultApiUsersPasswordResetTfaAppVerifyPostRequest
 */
export interface DefaultApiUsersPasswordResetTfaAppVerifyPostRequest {
    /**
     * Form required for resetting password
     * @type {PasswordResetAppVerificationForm}
     * @memberof DefaultApiUsersPasswordResetTfaAppVerifyPost
     */
    readonly passwordResetAppVerificationForm: PasswordResetAppVerificationForm
}

/**
 * Request parameters for usersPasswordResetTfaRecoveryCodePost operation in DefaultApi.
 * @export
 * @interface DefaultApiUsersPasswordResetTfaRecoveryCodePostRequest
 */
export interface DefaultApiUsersPasswordResetTfaRecoveryCodePostRequest {
    /**
     * Form required for resetting password
     * @type {PasswordResetRecoveryCodeForm}
     * @memberof DefaultApiUsersPasswordResetTfaRecoveryCodePost
     */
    readonly passwordResetRecoveryCodeForm: PasswordResetRecoveryCodeForm
}

/**
 * Request parameters for usersPasswordResetTfaSmsVerifyPost operation in DefaultApi.
 * @export
 * @interface DefaultApiUsersPasswordResetTfaSmsVerifyPostRequest
 */
export interface DefaultApiUsersPasswordResetTfaSmsVerifyPostRequest {
    /**
     * Form required for resetting password
     * @type {PasswordResetSmsVerificationForm}
     * @memberof DefaultApiUsersPasswordResetTfaSmsVerifyPost
     */
    readonly passwordResetSmsVerificationForm: PasswordResetSmsVerificationForm
}

/**
 * Request parameters for usersUserIdTwoFactorAuthSendResetLinkAsAdminPost operation in DefaultApi.
 * @export
 * @interface DefaultApiUsersUserIdTwoFactorAuthSendResetLinkAsAdminPostRequest
 */
export interface DefaultApiUsersUserIdTwoFactorAuthSendResetLinkAsAdminPostRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUsersUserIdTwoFactorAuthSendResetLinkAsAdminPost
     */
    readonly userId: string
}

/**
 * Request parameters for v2LoginPost operation in DefaultApi.
 * @export
 * @interface DefaultApiV2LoginPostRequest
 */
export interface DefaultApiV2LoginPostRequest {
    /**
     * Email and password form required for authentication
     * @type {LoginForm}
     * @memberof DefaultApiV2LoginPost
     */
    readonly loginForm: LoginForm
}

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Generate access token by grant code
     * @summary Generate access token
     * @param {DefaultApiAccessTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public accessTokenPost(requestParameters: DefaultApiAccessTokenPostRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).accessTokenPost(requestParameters.generateAccessTokenForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check the phone number is not registered to anyone
     * @summary Check already registered phone number
     * @param {DefaultApiCheckAlreadyRegisteredPhoneNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkAlreadyRegisteredPhoneNumber(requestParameters: DefaultApiCheckAlreadyRegisteredPhoneNumberRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkAlreadyRegisteredPhoneNumber(requestParameters.checkAlreadyRegisteredPhoneNumberForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete access token for use with scim
     * @summary Delete scim access token
     * @param {DefaultApiDeleteScimAccessTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteScimAccessToken(requestParameters: DefaultApiDeleteScimAccessTokenRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteScimAccessToken(requestParameters.organizationId, requestParameters.accessTokenId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disable saml as a means of authenticating members of the organization
     * @summary Disable saml
     * @param {DefaultApiDisableSamlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disableSaml(requestParameters: DefaultApiDisableSamlRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disableSaml(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disable scim for the organization
     * @summary Disable scim
     * @param {DefaultApiDisableScimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disableScim(requestParameters: DefaultApiDisableScimRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disableScim(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disable 2FA related to saml
     * @summary Disable two factor auth for saml
     * @param {DefaultApiDisableTwoFactorAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disableTwoFactorAuth(requestParameters: DefaultApiDisableTwoFactorAuthRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disableTwoFactorAuth(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow the use of saml as a means of authenticating members of the organization
     * @summary Enable saml
     * @param {DefaultApiEnableSamlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public enableSaml(requestParameters: DefaultApiEnableSamlRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).enableSaml(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable scim for the organization
     * @summary Enable scim
     * @param {DefaultApiEnableScimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public enableScim(requestParameters: DefaultApiEnableScimRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).enableScim(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable 2FA related to saml
     * @summary Enable two factor auth for saml
     * @param {DefaultApiEnableTwoFactorAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public enableTwoFactorAuth(requestParameters: DefaultApiEnableTwoFactorAuthRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).enableTwoFactorAuth(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enforce saml as a means of authenticating members of the organization
     * @summary Enforce saml
     * @param {DefaultApiEnforceSamlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public enforceSaml(requestParameters: DefaultApiEnforceSamlRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).enforceSaml(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate access token for use with scim
     * @summary Generate scim access token
     * @param {DefaultApiGenerateScimAccessTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateScimAccessToken(requestParameters: DefaultApiGenerateScimAccessTokenRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateScimAccessToken(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a new JWT for SSO from recieved JWT and sets it to cookie.
     * @summary Sets a JWT for SSO to cookie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getJwtSso(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getJwtSso(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns valid login methods for organization
     * @summary Get login options
     * @param {DefaultApiGetLoginOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLoginOptions(requestParameters: DefaultApiGetLoginOptionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLoginOptions(requestParameters.email, requestParameters.clientType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the metadata xml for SAML SSO of Moneytree.
     * @summary Returns the metadata xml.
     * @param {DefaultApiGetMetadataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMetadata(requestParameters: DefaultApiGetMetadataRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMetadata(requestParameters.spid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a new President Card JWT for SSO from recieved JWT and sets it to cookie.
     * @summary Sets a President Card JWT for SSO to the cookie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPcJwtSso(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPcJwtSso(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get configuration for use with saml
     * @summary Get saml configuration
     * @param {DefaultApiGetSamlConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSamlConfiguration(requestParameters: DefaultApiGetSamlConfigurationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSamlConfiguration(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get metadata
     * @summary Get saml metadata
     * @param {DefaultApiGetSamlMetadataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSamlMetadata(requestParameters: DefaultApiGetSamlMetadataRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSamlMetadata(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get access token for use with scim
     * @summary Get scim access tokens
     * @param {DefaultApiGetScimAccessTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getScimAccessToken(requestParameters: DefaultApiGetScimAccessTokenRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getScimAccessToken(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get configuration for use with scim
     * @summary Get scim configuration
     * @param {DefaultApiGetScimConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getScimConfiguration(requestParameters: DefaultApiGetScimConfigurationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getScimConfiguration(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate QR Code for two factor authentication
     * @summary Generate QR Code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTfaAppQrCode(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTfaAppQrCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download recovery code for two factor authentication
     * @summary Download recovery code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTfaAppRecoveryCode(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTfaAppRecoveryCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download recovery code for two factor authentication
     * @summary Download recovery code for SMS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTfaSmsRecoveryCode(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTfaSmsRecoveryCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check application startup and retrieve running branch name and image hash.
     * @summary Health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public healthCheckGet(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).healthCheckGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check if the user has access to the specified scope
     * @summary Access Scope Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public internalGet(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).internalGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves an access token for a given grant code or refresh token
     * @summary Retrieves an access token
     * @param {DefaultApiInternalV1AccessTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public internalV1AccessTokenPost(requestParameters: DefaultApiInternalV1AccessTokenPostRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).internalV1AccessTokenPost(requestParameters.accessTokenForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create or update an organization
     * @summary Create or update an organization
     * @param {DefaultApiInternalV1OrganizationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public internalV1OrganizationsPost(requestParameters: DefaultApiInternalV1OrganizationsPostRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).internalV1OrganizationsPost(requestParameters.universalOrganizationFormDefault, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Authenticate with your email and password.
     * @summary Login with Email and Password
     * @param {DefaultApiLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public loginPost(requestParameters: DefaultApiLoginPostRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).loginPost(requestParameters.loginWithPasswordForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Authenticate with App Authenticator.
     * @summary Login with App Authenticator
     * @param {DefaultApiLoginTwoFactorAuthAppPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public loginTwoFactorAuthAppPost(requestParameters: DefaultApiLoginTwoFactorAuthAppPostRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).loginTwoFactorAuthAppPost(requestParameters.loginWithTwoFactorAuthAppForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Authenticate with Recovery Code.
     * @summary Login with Recovery Code
     * @param {DefaultApiLoginTwoFactorAuthRecoveryCodePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public loginTwoFactorAuthRecoveryCodePost(requestParameters: DefaultApiLoginTwoFactorAuthRecoveryCodePostRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).loginTwoFactorAuthRecoveryCodePost(requestParameters.loginWithTwoFactorAuthRecoveryCodeForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Authenticate with Sms Authenticator.
     * @summary Login with Sms Authenticator
     * @param {DefaultApiLoginTwoFactorAuthSmsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public loginTwoFactorAuthSmsPost(requestParameters: DefaultApiLoginTwoFactorAuthSmsPostRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).loginTwoFactorAuthSmsPost(requestParameters.loginWithTwoFactorAuthSmsForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Logout
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public logoutPost(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).logoutPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Make saml optional as a means of authenticating members of the organization
     * @summary Make saml optional
     * @param {DefaultApiMakeSamlOptionalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public makeSamlOptional(requestParameters: DefaultApiMakeSamlOptionalRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).makeSamlOptional(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a SAML Response as an IDP for SAML SSO with Moneytree in the case of HTTP-POST binding.
     * @summary Returns a SAML Response as an IDP for SAML SSO.
     * @param {DefaultApiPostRedirectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postRedirect(requestParameters: DefaultApiPostRedirectRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postRedirect(requestParameters.spid, requestParameters.spid2, requestParameters.relayState, requestParameters.sAMLRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Register two factor authentication with App Authenticator.
     * @summary Register two factor authentication with App
     * @param {DefaultApiRegisterTfaAppVerificationCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registerTfaAppVerificationCode(requestParameters: DefaultApiRegisterTfaAppVerificationCodeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registerTfaAppVerificationCode(requestParameters.registerAppAuthForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Register two factor authentication with SMS.
     * @summary Register two factor authentication with SMS
     * @param {DefaultApiRegisterTfaSmsAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registerTfaSmsAuth(requestParameters: DefaultApiRegisterTfaSmsAuthRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registerTfaSmsAuth(requestParameters.registerSmsAuthForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns valid login methods for organization and save saml redirect url
     * @summary Save Saml Redirect Url
     * @param {DefaultApiSaveSamlRedirectUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveSamlRedirectUrl(requestParameters: DefaultApiSaveSamlRedirectUrlRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveSamlRedirectUrl(requestParameters.loginOptionForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get recovery codes for two factor authentication
     * @summary Get recovery codes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public twoFactorAuthAppGetRecoveryCodeGet(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).twoFactorAuthAppGetRecoveryCodeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reset two factor authentication
     * @summary Reset two factor authentication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public twoFactorAuthReset(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).twoFactorAuthReset(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update configuration for use with saml
     * @summary Update saml configuration
     * @param {DefaultApiUpdateSamlConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateSamlConfiguration(requestParameters: DefaultApiUpdateSamlConfigurationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateSamlConfiguration(requestParameters.organizationId, requestParameters.updateSamlConfigurationForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update configuration for use with scim
     * @summary Update scim configuration
     * @param {DefaultApiUpdateScimConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateScimConfiguration(requestParameters: DefaultApiUpdateScimConfigurationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateScimConfiguration(requestParameters.organizationId, requestParameters.updateScimConfigurationForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update password for specified user
     * @summary Update Password
     * @param {DefaultApiUpdateUserPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserPassword(requestParameters: DefaultApiUpdateUserPasswordRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserPassword(requestParameters.userId, requestParameters.updatePasswordForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change temporary password to normal password for specified user
     * @summary Update Password from temporary
     * @param {DefaultApiUpdateUserTempPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserTempPassword(requestParameters: DefaultApiUpdateUserTempPasswordRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserTempPassword(requestParameters.userId, requestParameters.updateTempPasswordForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check expiration of token for resetting password
     * @summary Check expiration of token
     * @param {DefaultApiUsersPasswordResetCheckGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public usersPasswordResetCheckGet(requestParameters: DefaultApiUsersPasswordResetCheckGetRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).usersPasswordResetCheckGet(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A password reset is executed
     * @summary Reset password confirmation
     * @param {DefaultApiUsersPasswordResetConfirmPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public usersPasswordResetConfirmPost(requestParameters: DefaultApiUsersPasswordResetConfirmPostRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).usersPasswordResetConfirmPost(requestParameters.passwordResetConfirmationForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * An email will be sent to you to reset your password
     * @summary Reset password
     * @param {DefaultApiUsersPasswordResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public usersPasswordResetPost(requestParameters: DefaultApiUsersPasswordResetPostRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).usersPasswordResetPost(requestParameters.passwordResetForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify password reset with app
     * @summary Verify password reset with app
     * @param {DefaultApiUsersPasswordResetTfaAppVerifyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public usersPasswordResetTfaAppVerifyPost(requestParameters: DefaultApiUsersPasswordResetTfaAppVerifyPostRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).usersPasswordResetTfaAppVerifyPost(requestParameters.passwordResetAppVerificationForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify password reset with recovery code
     * @summary Verify password reset with recovery code
     * @param {DefaultApiUsersPasswordResetTfaRecoveryCodePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public usersPasswordResetTfaRecoveryCodePost(requestParameters: DefaultApiUsersPasswordResetTfaRecoveryCodePostRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).usersPasswordResetTfaRecoveryCodePost(requestParameters.passwordResetRecoveryCodeForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify password reset with sms
     * @summary Verify password reset with sms
     * @param {DefaultApiUsersPasswordResetTfaSmsVerifyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public usersPasswordResetTfaSmsVerifyPost(requestParameters: DefaultApiUsersPasswordResetTfaSmsVerifyPostRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).usersPasswordResetTfaSmsVerifyPost(requestParameters.passwordResetSmsVerificationForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * An email will be sent to you to reset two factor authentication for admin
     * @summary Send to reset two factor authentication for admin
     * @param {DefaultApiUsersUserIdTwoFactorAuthSendResetLinkAsAdminPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public usersUserIdTwoFactorAuthSendResetLinkAsAdminPost(requestParameters: DefaultApiUsersUserIdTwoFactorAuthSendResetLinkAsAdminPostRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).usersUserIdTwoFactorAuthSendResetLinkAsAdminPost(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Authenticate with your email and password
     * @summary Login with Email and Password for Universal Users
     * @param {DefaultApiV2LoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public v2LoginPost(requestParameters: DefaultApiV2LoginPostRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).v2LoginPost(requestParameters.loginForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate saml response that is receipt from IdP
     * @summary Validate saml response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public validateSamlResponse(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).validateSamlResponse(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifies a President Card JWT for SSO and then returns it in the response.
     * @summary Verifies a President Card JWT for SSO and then returns it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public verifyPcJwtSso(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).verifyPcJwtSso(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify JWT.
     * @summary Verify ID Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public verifyTokenPost(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).verifyTokenPost(options).then((request) => request(this.axios, this.basePath));
    }
}


